import { render, staticRenderFns } from "./Menu_1_2.vue?vue&type=template&id=72930a84&scoped=true"
import script from "./Menu_1_2.vue?vue&type=script&lang=js"
export * from "./Menu_1_2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72930a84",
  null
  
)

export default component.exports